import { Field } from 'formik'
import { useEffect } from 'react'
import FormikURL from './FormikURL'
import { makeStyles } from '@material-ui/core/styles'
import FormikDatePicker, { formatDateValue } from './FormikDatePicker'

const InputFieldListItem = ({
  type,
  name,
  required,
  editMode,
  options,
  setFieldValue,
  value,
  values
}) => {
  const classes = useStyles()

  useEffect(() => {
    if (
      type === 'select' &&
      !value &&
      options?.length &&
      setFieldValue &&
      editMode
    ) {
      setFieldValue(name, options[0].value)
    }
    if (type === 'url' && !value && setFieldValue && editMode) {
      setFieldValue(name, '')
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  // Component ClassName
  const getComponentClassName = mode =>
    mode === 'input'
      ? { className: classes.inputField }
      : { className: classes.inputFieldDisplayMode }

  // Component type
  const getComponentType = () => ({
    ...(['text', 'url', 'date'].includes(type) ? { type: type } : { as: type })
  })

  // Component display value when not in Edit mode
  const getInputValue = () => {
    if (type === 'select') {
      const oneOption = options.find(o => o.value === value)
      return oneOption ? oneOption.text : ''
    }

    if (type === 'date') return formatDateValue(value, 'toYYYY-MM-DD')

    if (type === 'url') return <a href={value}>View</a>

    return value
  }

  // Component Props
  const getCompponentProps = (type, mode) => ({
    ...getComponentClassName(mode),
    ...getComponentType(),
    ...(name && { name: name }),
    ...(required && { required: required }),
    ...(['date', 'url'].includes(type) && {
      setFieldValue: setFieldValue,
      value: value
    })
  })

  const getInputField = (type, inputFieldProps) => {
    const copyOfInputProps = JSON.parse(JSON.stringify(inputFieldProps))
    const inputFields = {
      select: (
        <Field {...copyOfInputProps}>
          {options &&
            options.map(option => (
              <option
                key={option.key ? option.key : option.value}
                value={option.value}
              >
                {option.text}
              </option>
            ))}
        </Field>
      ),
      url: <FormikURL {...inputFieldProps} />,
      date: <FormikDatePicker {...inputFieldProps} />,
      default: <Field {...copyOfInputProps} />
    }

    return inputFields[type] || inputFields['default']
  }

  return (
    <div className={classes.root}>
      {/* <div className={classes.labels}>
        {label}
        {required && <div className={classes.required}>*</div>}
      </div> */}
      {editMode ? (
        getInputField(type, getCompponentProps(type, 'input'))
      ) : (
        <div {...getComponentClassName('display')}>{getInputValue()}</div>
      )}
    </div>
  )
}

export default InputFieldListItem

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '5px 0'
  },
  labels: {
    width: '100%',
    padding: '0 5px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '3px',
    color: theme.palette.tertiary.main,
    ...theme.typography.h3
  },
  required: {
    marginLeft: '5px',
    color: theme.palette.primary.accent,
    ...theme.typography.h3
  },
  inputField: {
    width: '100%',
    height: '25px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '1px 5px',
    borderRadius: '5px',
    border: `1px solid ${theme.palette.tertiary.accent}`,
    color: theme.palette.primary.main,
    ...theme.typography.p,
    '&:focus': {
      outline: 'none'
    }
  },
  inputFieldDisplayMode: {
    width: '100%',
    height: '25px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '1px 5px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    color: theme.palette.primary.main,
    ...theme.typography.p
  }
}))
